var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{staticClass:"filter__doctor",attrs:{"variant":"outline-orange","dropdown":"","text":_vm.selected}},_vm._l((_vm.items),function(item,index){return _c('b-dropdown-item',{key:index,on:{"click":function($event){return _vm.emitItemSelected(item)}}},[_vm._v("\n        "+_vm._s(item.text)+"\n    ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afd0b5fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Common/Filter/AppointmentDoctorFilter.vue
// module id = null
// module chunks = 